<template>
  <b-modal
    id="modal-order-view"
    ref="modal"
    v-model="open"
    size="ov-custom"
    centered
    hide-footer
    title="VIEW ORDER DETAILS"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-row class="mb-2">
        <b-col>
          <div class="d-flex align-items-center justify-content-lg-center">
            <order-status-banner
              class="status-bar"
              style="width:100%; font-size: 16px"
              :status-key="order.order_current_status.key"
              :color="order.order_current_status.color"
              :status-name="order.order_current_status.name"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-2">
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :style="{
              backgroundColor: getLightBackground(order.order_current_status.color),
              color: order.order_current_status.color
            }"
            class="col-container d-flex justify-content-between align-items-center align-items-lg-start flex-wrap position-relative"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left text-container">
              <div
                class="ml-lg-1 mr-lg-1"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  {{ order.waybill_number }}
                </div>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  COD: &nbsp;Rs.{{ __numberWithCommas(order.cod, true) }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Net Weight: &nbsp;{{ order.weight }}kg
                </h5>
                <h5 class="font-weight-bold font-small-4 ">
                  Created on: &nbsp;{{ __dateTimeFormatter(order.created_at) }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-top:9px"
                >
                  {{ order.description ? ( order.description.length > 190 ? order.description.substring(0,190) + '---' : order.description ) : 'No description' }}
                </h5>
              </div>
            </div>
            <div class="avatar-container">
              <b-avatar
                :text="'C'"
                size="26"
                :style="{
                  backgroundColor: order.order_current_status.color
                }"
              />
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :style="{
              backgroundColor: getLightBackground(order.order_current_status.color),
              color: order.order_current_status.color
            }"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Merchant Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant_business.business_name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 opacity-0-per d-none d-lg-flex"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Admin Contact: &nbsp;<b>{{ order.admin.phone }}</b>
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Merchant Contact: &nbsp;<b>{{ order.default_address ? order.default_address.default_contact_details.length > 0 ? order.default_address.default_contact_details[0].phone || 'N/A' : 'N/A' : 'N/A' }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Pickup Address: &nbsp;<b>{{ order.merchant_business.pickup_address }}</b>
                </h5>
                <h5
                  class="font-weight-bold font-small-4 mt-1"
                  style="margin-bottom:3px;"
                >
                  Origin City: &nbsp;<b>{{ order.origin_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Origin Warehouse: &nbsp;<b>{{ order.origin_warehouse.name }}</b>
                </h5>
              </div>
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :style="{
              backgroundColor: getLightBackground(order.order_current_status.color),
              color: order.order_current_status.color
            }"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Customer Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ order.customer_name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.customer_address }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.customer_email }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.customer_phone }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.customer_secondary_phone }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 mt-1"
                  style="margin-bottom:3px;"
                >
                  Destination City: &nbsp;<b>{{ order.destination_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Destination Warehouse: &nbsp;<b>{{ order.destination_warehouse.name }}</b>
                </h5>
              </div>
            </div>
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mx-2 mt-2 mb-2">
        <b-col class="d-flex justify-content-lg-end ml-1 ml-lg-0">
          <div
            v-for="flag_type in order.order_flags"
            :key="flag_type.id"
          >
            <b-badge :variant="getFlagBadgeColor(flag_type.type)">
              {{ flag_type.name }}
            </b-badge>
          </div>
        </b-col>
      </b-row>

      <b-tabs
        content-class="pt-1 min-height-59vh"
        fill
      >
        <b-tab
          title="Order History"
          class="p-2"
        >
          <app-timeline>
            <app-timeline-item
              v-for="(data, index) in timelineData"
              :key="index"
              :color="order.order_setting.is_pickup_enable && data.status.key === 'key_2' ? '#28a745' : `${data.status.color || '#007bff'}`"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <b-badge
                  :style="{ backgroundColor: data.status.color || '#007bff' }"
                  class="mb-2 mobile-column badge-height"
                >
                  <div class="text-center">
                    <h6
                      class="mb-0 text-sm text-wrap"
                      :style="{ color: '#fff' }"
                    >
                      {{ data.status.name }}
                    </h6>
                  </div>
                </b-badge>
                <small class="date-container">{{ __dateTimeFormatter(data.date_time) }}  {{ data.date_time_ago }}</small>
              </div>
              <p>{{ data.reason || '' }}</p>
              <div v-if="(index=='0' && order.rider_signature != null)">
                <b-button
                  v-if="order.order_current_status.key == 'key_7' || order.order_current_status.key == 'key_13' || order.order_current_status.key == 'key_14'"
                  variant="outline-primary"
                  size="sm"
                  class="btn m-1 mr-1 btn-outline-primary btn-sm"
                  @click="openSignatureModal()"
                >
                  View Signature
                </b-button>
              </div>
              <div v-if="(shouldShowProofBtn(data))">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="btn m-1 mr-1 btn-outline-primary btn-sm"
                  @click="openProofDocModal(data.proofs)"
                >
                  View Proof Images
                </b-button>
              </div>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media v-if="data.user && typeof data.user === 'object'">
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h5>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h5>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span>{{ data.user_role || '' }}</span>
                </b-media>
                <h6
                  v-else
                  class="font-weight-bolder"
                >
                  {{ data.user || 'Automatically Generated' }}
                </h6>
              </div>
            </app-timeline-item>
          </app-timeline>
        </b-tab>
        <b-tab
          title="Invoice History"
          class="px-2"
          @click="getOrderInvoiceTimeline()"
        >
          <app-timeline v-if="invoiceTimelineData.length>0">
            <div
              class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
              style="padding:10px;"
            >
              <div class="font-small-5 font-weight-bold text-center text-dark">
                Invoice No : {{ invoiceTimelineData[0].invoice_no }}
              </div>
            </div>
            <app-timeline-item
              v-for="(data, index) in invoiceTimelineData"
              :key="index"
              :variant="'light-'+data.status.color ? data.status.color : 'primary'"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <div>
                  <h6>{{ data.status.name }}</h6>
                  <h5 class="font-small-3">
                    {{ data.invoice_amount }}
                  </h5>
                </div>
                <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{ data.date_time_ago }}</small>
              </div>
              <p>{{ data.reason || '' }}</p>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media v-if="data.user && typeof data.user === 'object'">
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span class="text-muted">{{ data.user_role || '' }}</span>
                </b-media>
                <h6
                  v-else
                  class="font-weight-bolder"
                >
                  {{ data.user || 'Automatically Generated' }}
                </h6>
              </div>
            </app-timeline-item>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded Invoice history
          </div>
        </b-tab>
        <b-tab
          :title="`General Remarks (${remarksCount})`"
          @click="getOrderRemarkTimeLine()"
        >
          <div v-if="order.remark && order.remark.length">
            <remark-table
              :remarks="order.remark"
              :order-id="id"
            />
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded remark history
          </div>
        </b-tab>
        <b-tab
          title="Flag History"
        >
          <flag-details :flag_data="order_flags_history" />
        </b-tab>
      </b-tabs>

    </b-overlay>
    <b-modal
      id="signature-view"
      v-model="signatureOpen"
      size="sm"
      centered
      hide-footer
      title="VIEW SIGNATURE"
    >
      <div class="signature-container">

        <img
          :src="`${cdn}${order.rider_signature}`"
          alt="Rider's Signature"
          class="signature"
        >
        <!-- <b-button
          class="btn m-1 btn-outline-primary btn-sm"
          variant="outline-primary"
          size="sm"
          @click="downloadImg(`${cdn}${order.rider_signature}`, `${order.waybill_number}`)"
        >Download</b-button> -->
      </div>
    </b-modal>
    <b-modal
      id="proof-doc-open-view"
      v-model="proofDocOpen"
      size="lg"
      centered
      hide-footer
      title="VIEW PROOF IMAGES"
    >
      <div>
        <b-row>
          <b-col
            v-for="(p, i) in selectedProofs"
            :key="p.id || i"
            cols="6"
            class="mb-2"
          >
            <img
              :src="p.url"
              alt="Proof"
              class="proof-image"
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BTabs,
  BTab,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BMedia,
  BButton,
} from 'bootstrap-vue'
import OrderStatusBanner from '@core/components/status/OrderStatusBanner.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import displayAmountWithCurrency from '@core/mixins/currency'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import emptyOrderPayload from '@/models/order'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import RemarkTable from '@/components/orders/remarks/RemarkTable.vue'
import FlagDetails from '@/components/orders/FlagHistoryDetails.vue'
import StatusMixin from '@core/mixins/status'

const OrderRepository = RepositoryFactory.get('order')

export default {
  name: 'ViewOrderModal',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BModal,
    BOverlay,
    BTabs,
    BTab,
    BAvatar,
    BRow,
    BCol,
    BBadge,
    BMedia,
    BButton,
    OrderStatusBanner,
    AppTimeline,
    AppTimelineItem,
    RemarkTable,
    FlagDetails,
  },
  mixins: [SuccessMessage, ErrorMessage, displayAmountWithCurrency, StatusMixin],
  data() {
    return {
      avatarText,
      open: false,
      signatureOpen: false,
      modalLoading: false,
      id: null,
      timelineData: [],
      invoiceTimelineData: [],
      remarksCount: 0,
      loadingRemarks: false,
      order: emptyOrderPayload(),
      fields: [
        { key: 'remarkedBy', label: 'Remarked By', sortable: true },
        { key: 'remark', label: 'Remark', sortable: false },
        { key: 'created_at', label: 'Remark Date', sortable: false },
      ],
      cdn: process.env.VUE_APP_BUCKET_URL,
      myVariant: '',
      proofDocOpen: false,
      selectedProofs: [],
      order_flags_history: [],
      currency_type: 'Rs',
    }
  },
  computed: {
    filteredOrderFlags() {
      if (!this.order || !this.order.order_flags) return []
      return this.order.order_flags.filter(entry => {
        const flag = entry.order_flag || entry
        // Exclude flags that are non-system and also not merchant-enabled
        if (Object.prototype.hasOwnProperty.call(flag, 'is_system') && Object.prototype.hasOwnProperty.call(flag, 'is_merchant_enable')) {
          return !(flag.is_system === false && flag.is_merchant_enable === false)
        }
        // If properties are missing, keep the flag by default
        return true
      })
    },
  },
  methods: {
    async openModal(id) {
      this.open = true
      this.id = id
      this.remarksCount = 0
      await this.fetchOrderDetails()
      await this.getOrderTimeline()
      await this.getOrderFlagTimeLine()
    },
    async getOrderTimeline() {
      try {
        this.loading = true
        const { data } = await OrderRepository.getOrderTimeLine(this.id)
        this.timelineData = (data.data || []).map(item => ({
          ...item,
          proofs: Array.isArray(item.proofs) ? item.proofs : [],
        }))
        this.loading = false
      } catch (e) {
        this.timelineData = []
        this.loading = false
      }
    },
    openSignatureModal() {
      this.signatureOpen = true
    },
    async getOrderInvoiceTimeline() {
      try {
        this.loading = true
        const { data } = await OrderRepository.getOrderInvoiceTimeLine(this.id)
        this.invoiceTimelineData = data.data
        if (this.invoiceTimelineData.length > 0) {
          const pendingCopy = JSON.parse(JSON.stringify(data.data.slice().pop()))
          pendingCopy.status.name = 'Created'
          pendingCopy.status.color = 'success'
          this.invoiceTimelineData.push(pendingCopy)
        }
        this.loading = false
      } catch (e) {
        this.invoiceTimelineData = []
        this.loading = false
      }
    },
    async getOrderDetails() {
      try {
        this.modalLoading = true
        const { data } = (await OrderRepository.getOrderDetails(this.id)).data
        this.order = data
        this.myVariant = this.order.status.color
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    getFlagBadgeColor(type) {
      if (type === 'flag_1') {
        return 'light-info'
      }
      if (type === 'flag_2') {
        return 'light-danger'
      }
      if (type === 'flag_3') {
        return 'light-primary'
      }
      if (type === 'flag_4') {
        return 'light-dark'
      }
      if (type === 'flag_5') {
        return 'light-success'
      }
      if (type === 'flag_6') {
        return 'light-warning'
      }
      if (type === 'flag_7') {
        return 'light-danger'
      }
      if (type === 'flag_8') {
        return 'light-info'
      }
      return 'light-primary'
    },
    downloadImg(urlFromFunction, wayBillNumber) {
      const xhr = new XMLHttpRequest()
      const fileName = `${wayBillNumber}_customer_signature.png`
      const dataType = 'png'
      xhr.onload = function c() {
        const arr = new Uint8Array(this.response)
        const raw = String.fromCharCode.apply(null, arr)
        const b64 = btoa(raw)
        const dataURL = `data:image/${dataType};base64,${b64}`
        const element = document.createElement('a')
        element.href = dataURL
        element.setAttribute('download', fileName)
        document.body.appendChild(element)
        element.click()
        element.remove()
      }
      xhr.open('GET', urlFromFunction)
      xhr.responseType = 'arraybuffer'
      xhr.send()
    },
    openProofDocModal(proofs) {
      this.selectedProofs = proofs
      this.proofDocOpen = true
    },
    shouldShowProofBtn(data) {
      const allowed = ['key_6', 'key_7', 'key_13', 'key_14', 'key_15', 'key_17']
      return Array.isArray(data.proofs) && data.proofs.length > 0 && allowed.includes(data.status?.key)
    },
    async fetchOrderDetails() {
      try {
        this.modalLoading = true
        const { data } = (await OrderRepository.fetchOrderDetailsById(this.id)).data
        this.order = data
        this.myVariant = this.order.order_current_status.color
        this.remarksCount = data.remark || 0
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    async getOrderRemarkTimeLine() {
      this.loadingRemarks = true
      try {
        const { data } = await OrderRepository.getOrderRemarkTimeLine(this.id)
        this.$set(this.order, 'remark', data.remark)
      } catch (e) {
        this.order.remark = []
      }
    },
    async getOrderFlagTimeLine() {
      try {
        const { data } = await OrderRepository.getOrderFlagTimeLine(this.id)
        this.order_flags_history = data.order_flags
      } catch (e) {
        this.order_flags_history = []
      }
    },
  },
}
</script>

<style scoped >
  .badge-height {
    margin-bottom: 40px !important;
  }
  .signature-container {
    display: flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
  }
  h5 {
    color: #000000;
  }
  .order-status-name {
    color: white;
  }
  .text-container {
    max-width: 100%; /* Set your desired maximum width */
    word-wrap: break-word; /* Break long words to the next line */
    white-space: normal; /* Allow whitespace to wrap */
  }
  .date-container {
    max-width: 100px; /* Set your desired maximum width */
    word-wrap: break-word; /* Break long words to the next line */
    white-space: normal; /* Allow whitespace to wrap */
    text-align: right;
    margin-top: 7px;
    font-weight: 500;
  }
  .col-container {
    width: 100%;
    min-height: 100%;
  }
  .sub-title{
    font-size:large;
  }
  p {
    font-weight: bold;
  }
  .status-bar {
  padding: 1rem;
}
.col-container {
  position: relative;
}

.avatar-container {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
}
.proof-image {
  width: 100%;
  height: auto;
  max-height: 250px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: transform 0.2s ease;
  background-color: #f8f9fa;
  padding: 8px;
  box-sizing: border-box;
}
.proof-image:hover {
  transform: scale(1.02);
}
@media (max-width: 1200px) {
  .avatar-container {
    position: static;
    margin: 0;
  }
}
@media (max-width: 767px) {
  .status-bar {
    padding: 0.5rem;
  }
  .col-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #modal-order-view {
      max-width: 100%;
      width: 100%;
    }
    .view-sign-button {
    display: block;
  }
  .date-container {
    text-align: left;
  }
  .mobile-column {
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .avatar-container {
    justify-content: center;
    width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .status-bar {
    padding: 0.5rem;
  }
  .col-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #modal-order-view {
      max-width: 100%;
      width: 100%;
    }
    .view-sign-button {
    display: block;
  }
  .date-container {
    text-align: left;
  }
  .mobile-column {
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .avatar-container {
    justify-content: center;
    width: 100%;
  }
}
</style>
